import { uniq } from 'lodash';
import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { ValueSet } from '../../../../../../../common/model/input/value-sets/types';
import { CUSTOM_VALUE_SET_NAME } from '../../../../../../../common/model/input/value-sets/value-sets';
import { Valence } from '../../../../../../../common/model/types';
import { steps } from '../blocks/shared';

export function getValueSetMinMax(valueSet: ValueSet) {
  const firstValue = Object.values(Object.values(Object.values(valueSet))[0])[0]; // :D
  const min = Object.values(valueSet).reduce(
    (maxValue, impactValues) => Math.min(maxValue, impactValues[Valence.POSITIVE], impactValues[Valence.NEGATIVE]),
    firstValue,
  );
  const max = Object.values(valueSet).reduce(
    (maxValue, impactValues) => Math.max(maxValue, impactValues[Valence.POSITIVE], impactValues[Valence.NEGATIVE]),
    0,
  );
  return { min, max };
}

export function getNormalizedValue(value: number, min: number, max: number, valueSetName: string) {
  if (valueSetName === CUSTOM_VALUE_SET_NAME) {
    return normalize(value, min, max, steps - 1);
  }

  // Convert existing value sets to range from 1 to "steps",
  // i.e. 1-5 instead of 0-5 which is reserved for custom value sets
  const normalized = normalize(value, min, max, steps - 2);
  return normalized + 1;
}

function normalize(value: number, min: number, max: number, rangeMax: number) {
  if (max === min) {
    return Math.round(rangeMax / 2);
  }
  const zeroToOne = (value - min) / (max - min);
  const zeroToRangeMax = zeroToOne * rangeMax;
  const rounded = Math.round(zeroToRangeMax);
  return rounded;
}

export function getPossibleUniqueValueOfValence(
  impactCategories: ImpactCategoryId[],
  valence: Valence,
  valueSet: ValueSet,
) {
  const valuesOfValence = impactCategories.map(impactCategoryId => valueSet[impactCategoryId][valence]);
  const uniqValues = uniq(valuesOfValence);
  const onlyUniqValue = uniqValues.length === 1 ? uniqValues[0] : undefined;
  return onlyUniqValue;
}
